import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

export const Administration = () => {
  return (
    <Box sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
      <Paper elevation={3} sx={{ p: { xs: 1.5, sm: 2, md: 3 }, borderRadius: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
          <AdminPanelSettingsIcon sx={{ color: '#455a64', fontSize: 28 }} />
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#455a64' }}>
            Administration
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ color: '#64748b' }}>
          System administration — coming soon.
        </Typography>
      </Paper>
    </Box>
  );
};

export default Administration;
